import React, { Fragment } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";

import appRoutes from "./appRoutes";

import DashboardLayout from "../containers/Layout/Dashboard";
import LoginPage from "../pages/Login";
import ForgotPasswordPage from "../pages/ForgotPassword";
import ResetPasswordPage from "../pages/ResetPassword";
import CreatePasswordPage from "../pages/CreatePassword";
import SupportChatPage from "../pages/SupportChat";
import ViewTicketPage from "../pages/Tickets/viewTickets";
import EditTicketPage from "../pages/Tickets/editTicket";
import GenerateTicketPage from "../pages/Tickets/generateTicket";
import ReceivedResultsPage from "../pages/Tickets/receivedResults";
//import ViewBookingsPage from "../pages/Bookings/viewBookings";
//import EditBookingPage from "../pages/Bookings/editBooking";
//import GenerateBookingPage from "../pages/Bookings/generateBooking";
import ViewLegalPage from "../pages/Legal/viewLegal";
import EditLegalPage from "../pages/Legal/editLegal";
import ViewFaqsPage from "../pages/Faqs/viewFaqs";
import ChangePasswordPage from "../pages/ChangePassword";
import ChangePinPage from "../pages/ChangePin";
import PharmaciesPage from "../pages/Pharmacies";
import LoginsPage from "../pages/Logins";
import PatientsInQueuePage from "../pages/Patients/patientsInQueue";
import PatientsPage from "../pages/Patients/patients";
import DoctorsInQueuePage from "../pages/Doctors/doctorsInQueue";
import DoctorNewApplicationPage from "../pages/Doctors/doctorNewApplication";
import DoctorNewApplicationDetails from "../pages/Doctors/doctorNewApplicationDetails";
import DoctorApprovedPage from "../pages/Doctors/doctorApproved";
import DoctorRejectedPage from "../pages/Doctors/doctorRejected";
import DoctorRejectedDetailPage from "../pages/Doctors/doctorRejectedDetail";
import DoctorApprovedDetailPage from "../pages/Doctors/doctorApprovedDetail";
//import NursesInQueuePage from "../pages/Nurses/nursesInQueue";
//import NurseNewApplicationPage from "../pages/Nurses/nurseNewApplication";
//import NurseNewApplicationDetails from "../pages/Nurses/nurseNewApplicationDetails";
//import NurseApprovedPage from "../pages/Nurses/nurseApproved";
//import NurseRejectedPage from "../pages/Nurses/nurseRejected";
//import NurseRejectedDetailPage from "../pages/Nurses/nurseRejectedDetail";
//import NurseApprovedDetailPage from "../pages/Nurses/nurseApprovedDetail";
import NatureOfConsultPage from "../pages/NatureOfConsult";
import ConsultCostPage from "../pages/ConsultCost";
import InstantSwitchConsultCostPage from "../pages/ConsultCost/InstantSwitchConsultCost";
import instantHushConsultCostPage from "../pages/ConsultCost/instantHushConsultCost";
import PastConsultsPage from "../pages/ConsultHistory/pastConsults";
import UnansweredConsultPage from "../pages/ConsultHistory/unansweredConsult";
import ConsultDetailPage from "../pages/ConsultHistory/consultDetail";
import DrugDatabasePage from "../pages/DrugDatabase";
import ConsultCostMedicarePage from "../pages/ConsultCostMedicare";

import InstantSwitchMBSCostPage from "../pages/ConsultCostMedicare/instantSwitchMBSCost";

import InstantSwitchOnlineAssessments from "../pages/InstantSwitch/onlineAssessments";
import InstantSwitchOnlineAssessmentsDetails from "../pages/InstantSwitch/onlineAssessmentsDetails";

import ViewCouponsListPage from "../pages/Coupons/viewCouponsList";
import CouponDetailsPage from "../pages/Coupons/couponDetails";

import ForumListPage from "../pages/Forum/forumList";
import ForumPostDetails from "../pages/Forum/forumPostDetails";
import CreateForumPostPage from "../pages/Forum/createPost";

// import LogFilePage from "../pages/LogFile";
// import SecuritySettingPage from "..//pages/SecuritySetting";
import AppointmentCountsPage from "../pages/ConsultHistory/appointmentCounts";

import PromotionPage from "../pages/Promotions/promotion";

// traditional prescription list
import TraditionalPrescriptionListPage from "../pages/TraditionalPrescription/TraditionalPrescriptionList";

// Instant Hush
import InstantHushOnlineAssessments from "../pages/InstantHush/ihOnlineAssessments";
import InstantSwitchOnlineAssessmentDetails from "../pages/InstantHush/ihOnlineAssessmentDetails";
import ConsultRequestsPage from "../pages/Patients/consultRequests";
// import BookingsPage from "../pages/Patients/bookings";
import AppSettings from "../pages/AppSettings";

import socket from "../utils/socket";
import MedicinalCannabisConsultCost from "../pages/ConsultCost/MedicinalCannabisConsultCost";
import MedicinalCannabisOnlineAssessments from "../pages/MedicinalCannabis/MedicinalCannabisOnlineAssessments";
import MedicinalCannabisOnlineAssessmentsDetails
  from "../pages/MedicinalCannabis/MedicinalCannabisOnlineAssessmentsDetails";
import ShiftsPage from "../pages/InstantExtra/ShiftsPage";
import InstantExtraOnlineAssessments from "../pages/InstantExtra/instantExtraOnlineAssessments";
import InstantExtraOnlineAssessmentsDetails from "../pages/InstantExtra/instantExtraOnlineAssessmentsDetails";
import BlockedDrugsPage from "../pages/BlockedDrugs";

// we will use this components for the restricted routes which can be accessed after login only
const RestrictedRoute = props => (
  <Fragment>
    {props.isLoggedIn === true ? (
      <Route exact path={props.path} component={props.component} />
    ) : (
      <Redirect to={appRoutes.login} from={props.path} />
    )}
  </Fragment>
);

// We will use this component for public routes which cannot be access after login
const PublicRoute = props => (
  <Fragment>
    {props.isLoggedIn === false ? (
      <Route exact path={props.path} component={props.component} />
    ) : (
      <Redirect to={appRoutes.supportChat} from={props.path} />
    )}
  </Fragment>
);

const AppRoutes = props => {
  const auth = props.auth;

  if (!auth.isLoggedIn || !auth.user) {
    try {
      console.log("Disconnect socket from index as user is not logged in");
      socket.disconnect();
    } catch (e) {
      console.log("Error during Doctor try to disconnect from index route: ", e);
    }
  }

  return (
    <div>
      <Router>
        <Switch>
          <Redirect exact from="/" to={appRoutes.login} />
          <PublicRoute
            path={appRoutes.login}
            component={LoginPage}
            isLoggedIn={auth.isLoggedIn}
          />
          <PublicRoute
            path={appRoutes.forgotPassword}
            component={ForgotPasswordPage}
            isLoggedIn={auth.isLoggedIn}
          />
          <Route
            exact
            path={appRoutes.resetPassword}
            component={ResetPasswordPage}
          />
          <Route
            exact
            path={appRoutes.createPassword}
            component={CreatePasswordPage}
          />
          <Redirect exact from="/app" to={appRoutes.supportChat} />
          <Route path="/app">
            <Switch>
              <DashboardLayout>
                <RestrictedRoute
                  path={appRoutes.supportChat}
                  component={SupportChatPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.viewTickets}
                  component={ViewTicketPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.generateTicket}
                  component={GenerateTicketPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.editTicket + "/:id"}
                  component={EditTicketPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.receivedResults}
                  component={ReceivedResultsPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                {/* <RestrictedRoute
                  path={appRoutes.viewBookings}
                  component={ViewBookingsPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.editBooking}
                  component={EditBookingPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.generateBooking}
                  component={GenerateBookingPage}
                  isLoggedIn={auth.isLoggedIn}
                /> */}
                <RestrictedRoute
                  path={appRoutes.viewLegal}
                  component={ViewLegalPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.editLegal}
                  component={EditLegalPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.faqs}
                  component={ViewFaqsPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.changePassword}
                  component={ChangePasswordPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.changePin}
                  component={ChangePinPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.pharmacies}
                  component={PharmaciesPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.drugDatabase}
                  component={DrugDatabasePage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.blockedDrugs}
                  component={BlockedDrugsPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.loginsSupportStaff}
                  component={LoginsPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.patientsInQueue}
                  component={PatientsInQueuePage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                    path={appRoutes.consultRequests}
                    component={ConsultRequestsPage}
                    isLoggedIn={auth.isLoggedIn}
                /> 
                {/* <RestrictedRoute
                    path={appRoutes.bookings}
                    component={BookingsPage}
                    isLoggedIn={auth.isLoggedIn}
                /> */}
                <RestrictedRoute
                  path={appRoutes.patients}
                  component={PatientsPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.doctorsInQueue}
                  component={DoctorsInQueuePage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.doctorNewApplications + "/:id"}
                  component={DoctorNewApplicationDetails}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.doctorNewApplications}
                  component={DoctorNewApplicationPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.doctorApproved}
                  component={DoctorApprovedPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.doctorRejected}
                  component={DoctorRejectedPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.doctorRejected + "/:id"}
                  component={DoctorRejectedDetailPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.doctorApproved + "/:id"}
                  component={DoctorApprovedDetailPage}
                  isLoggedIn={auth.isLoggedIn}
                />

                {/* <RestrictedRoute
                  path={appRoutes.nursesInQueue}
                  component={NursesInQueuePage}
                  isLoggedIn={auth.isLoggedIn}
                /> */}
                {/* <RestrictedRoute
                  path={appRoutes.nurseNewApplications + "/:id"}
                  component={NurseNewApplicationDetails}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.nurseNewApplications}
                  component={NurseNewApplicationPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.nurseApproved}
                  component={NurseApprovedPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.nurseRejected}
                  component={NurseRejectedPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.nurseRejected + "/:id"}
                  component={NurseRejectedDetailPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.nurseApproved + "/:id"}
                  component={NurseApprovedDetailPage}
                  isLoggedIn={auth.isLoggedIn}
                /> */}
                <RestrictedRoute
                  path={appRoutes.natureOfConsult}
                  component={NatureOfConsultPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.consultCosts}
                  component={ConsultCostPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.consultCostsInstantSwitch}
                  component={InstantSwitchConsultCostPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.consultCostsMedicinalCannabis}
                  component={MedicinalCannabisConsultCost}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.instantSwitchOnlineAssessments}
                  component={InstantSwitchOnlineAssessments}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.instantExtraDoctorSchedule}
                  component={ShiftsPage}
                  isLoggedIn={auth.isLoggedIn}
                />

                <RestrictedRoute
                  path={appRoutes.instantExtraAssessments}
                  component={InstantExtraOnlineAssessments}
                  isLoggedIn={auth.isLoggedIn}
                />

                <RestrictedRoute
                  path={appRoutes.instantExtraAssessments + "/:id"}
                  component={InstantExtraOnlineAssessmentsDetails}
                  isLoggedIn={auth.isLoggedIn}
                />
                {/*<RestrictedRoute*/}
                {/*  path={appRoutes.smokingCessationDoctorSchedule}*/}
                {/*  component={DoctorSmokingCessationShiftsPage}*/}
                {/*  isLoggedIn={auth.isLoggedIn}*/}
                {/*/>*/}
                {/*<RestrictedRoute*/}
                {/*  path={appRoutes.medicinalCannabisDoctorSchedule}*/}
                {/*  component={DoctorMedicinalCannabisShiftsPage}*/}
                {/*  isLoggedIn={auth.isLoggedIn}*/}
                {/*/>*/}
                <RestrictedRoute
                  path={appRoutes.instantSwitchOnlineAssessmentsDetails + "/:id"}
                  component={InstantSwitchOnlineAssessmentsDetails}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.medicinalCannabisOnlineAssessments}
                  component={MedicinalCannabisOnlineAssessments}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.medicinalCannabisOnlineAssessmentsDetails + "/:id"}
                  component={MedicinalCannabisOnlineAssessmentsDetails}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.instantHushOnlineAssessments}
                  component={InstantHushOnlineAssessments}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.instantHushOnlineAssessmentsDetails + "/:id"}
                  component={InstantSwitchOnlineAssessmentDetails}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.consultCostsInstantHush}
                  component={instantHushConsultCostPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.consultCostsMedicare}
                  component={ConsultCostMedicarePage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.instantSwitchConsultCostMedicare}
                  component={InstantSwitchMBSCostPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.pastConsults}
                  component={PastConsultsPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.unansweredConsultRequests}
                  component={UnansweredConsultPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.pastConsults + "/:id"}
                  component={ConsultDetailPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.appointmentCounts}
                  component={AppointmentCountsPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.viewCouponsList}
                  component={ViewCouponsListPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.viewCouponDetail + "/:id"}
                  component={CouponDetailsPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.viewForum}
                  component={ForumListPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.createForumPost}
                  component={CreateForumPostPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.forumPostDetails + "/:id"}
                  component={ForumPostDetails}
                  isLoggedIn={auth.isLoggedIn}
                />
                 <RestrictedRoute
                  path={appRoutes.marketing}
                  component={PromotionPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.traditionalPrescriptionList}
                  component={TraditionalPrescriptionListPage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.appSettings}
                  component={AppSettings}
                  isLoggedIn={auth.isLoggedIn}
                />
                {/* <RestrictedRoute
                  path={appRoutes.logFile}
                  component={LogFilePage}
                  isLoggedIn={auth.isLoggedIn}
                />
                <RestrictedRoute
                  path={appRoutes.securitySetting}
                  component={SecuritySettingPage}
                  isLoggedIn={auth.isLoggedIn}
                /> */}
              </DashboardLayout>
            </Switch>
          </Route>{" "}
          {/* <Route component={Error404} path="/404" /> */}
          <Redirect from="*" to="/404" />
        </Switch>
      </Router>
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(AppRoutes);
